<template lang="html">
    <div :is="'reservation-link'" :direction="0" ></div>
</template>

<script>
import ReservationLink from './ReservationLink'
export default {
    components:{
        ReservationLink
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ReservationLinkIn.vue?72b74c5c